import { Link } from 'react-router-dom';
import { Avatar } from '@mui/material';

const AuthorChip = ({ displayName, authorId, authorUserId, avatarUrl }) => {
    const nameEl = (
        <>
            <span style={{ color: '#1976d2', textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: '3px' }}>
                {displayName}
            </span>
            {avatarUrl && (
                <>
                    {' '}
                    <Avatar
                        src={avatarUrl}
                        alt={displayName}
                        sx={{ width: 26, height: 26, display: 'inline-block', verticalAlign: 'baseline', position: 'relative', top: '5px' }}
                        imgProps={{ onError: (e) => { e.target.onerror = null; e.target.src = '/default-author.svg'; } }}
                    />
                </>
            )}
        </>
    );

    if (authorId) return <Link to={`/author/${authorId}`} style={{ textDecoration: 'none' }}>{nameEl}</Link>;
    if (authorUserId) return <Link to={`/profile/${authorUserId}`} style={{ textDecoration: 'none' }}>{nameEl}</Link>;
    return <span style={{ color: 'inherit' }}>{displayName}</span>;
};

const normalizeAuthor = (a) => ({
    displayName: a.display_name ?? a.displayName,
    authorId: a.author_id ?? a.authorId,
    authorUserId: a.author_user_id ?? a.authorUserId,
    avatarUrl: a.avatar_url ?? a.avatarUrl,
    id: a.id,
});

const joinAuthors = (authors) => {
    if (authors.length === 1) return <AuthorChip {...normalizeAuthor(authors[0])} />;
    return authors.map((a, i) => {
        const props = normalizeAuthor(a);
        return (
            <span key={props.id ?? i}>
                <AuthorChip {...props} />
                {i < authors.length - 2 ? ', ' : i === authors.length - 2 ? ' & ' : ''}
            </span>
        );
    });
};

// authors array (new) takes priority; falls back to legacy single-author props
const AuthorLink = ({ author, authorId, authorUserId, avatarUrl, authors }) => {
    if (authors && authors.length > 0) {
        return <>Recipe Courtesy of {joinAuthors(authors)}</>;
    }

    if (!author) return null;

    // Legacy single-author path
    const chip = (
        <>
            <span style={{ color: '#1976d2', textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: '3px' }}>
                {author}
            </span>
            {avatarUrl && (
                <>
                    {' '}
                    <Avatar
                        src={avatarUrl}
                        alt={author}
                        sx={{ width: 26, height: 26, display: 'inline-block', verticalAlign: 'baseline', position: 'relative', top: '5px' }}
                        imgProps={{ onError: (e) => { e.target.onerror = null; e.target.src = '/default-author.svg'; } }}
                    />
                </>
            )}
        </>
    );

    if (authorId) return <>Recipe Courtesy of <Link to={`/author/${authorId}`} style={{ textDecoration: 'none' }}>{chip}</Link></>;
    if (authorUserId) return <>Recipe Courtesy of <Link to={`/profile/${authorUserId}`} style={{ textDecoration: 'none' }}>{chip}</Link></>;
    return <>Recipe Courtesy of {author}</>;
};

export default AuthorLink;
